import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
// import CheckBox from '~/componentes/CustomForm/Check/styles/CheckBox';

import { Container, SecaoTicket, ItemTicket, ToggleSwitch } from './styles';
// import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
// import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import ShowLoading from '~/utils/ShowLoading';
// import Acoordion from '~/componentes/Acoordion';
// import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';
import IconRestaurar from '~/assets/icones/IconModalAcessoRefresh.svg';
import sistemaListStore from '~/pages/Sistema/componentes/SistemaList/ThisMainComponent/thisStore';

function CreateContent({ mountedData }) {
  // eslint-disable-next-line no-unused-vars
  const [tipo, setTipo] = useState(mountedData?.tipoOS);
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);
  const [totalHora, setTotalHora] = useState('00:00');
  const [totalPosHorario, setTotalPosHorario] = useState('00:00');
  const [tickets, setTickets] = useState([]);

  const formatarHoraDecimal = horaDecimal => {
    if (!horaDecimal) return '00:00';

    const horas = Math.floor(horaDecimal);
    const minutosDecimal = horaDecimal - horas;
    const minutos = Math.round(minutosDecimal * 60);

    return horas.toString().padStart(2, '0') + ':' + minutos.toString().padStart(2, '0');
  };

  const getPrimeiraHoraInicial = item =>
    (item?.horarios || []).reduce((menor, horario) => {
      if (!horario?.horaInicial) return menor;
      return !menor || horario.horaInicial < menor ? horario.horaInicial : menor;
    }, null) || '';

  const isMesmoTicket = (a, b) =>
    a?.id != null && b?.id != null
      ? a.id === b.id
      : a?.idMovidesk === b?.idMovidesk &&
        a?.idMovideskAction === b?.idMovideskAction &&
        a?.idTicket === b?.idTicket &&
        a?.tipo === b?.tipo;

  const atualizarCampoTicket = (item, campo, valor) => {
    setTickets(prev => prev.map(t => (isMesmoTicket(t, item) ? { ...t, [campo]: valor } : t)));
  };

  const { state } = React.useContext(sistemaListStore);
  const { editShow } = state?.modal || {};

  // Só pode editar/excluir/restaurar ticket enquanto a OS estiver
  // aguardando aprovação do coordenador (A) ou reprovada (R/S).
  const podeEditar =
    mountedData?.statusAprovacao === 'A' ||
    mountedData?.statusAprovacao === 'R' ||
    mountedData?.statusAprovacao === 'S';
  const modoEdicao = !editShow && podeEditar;

  /**
   * Busca tickets do MoviDesk sob demanda (botão, só disponível em modo de edição).
   * Compara pelo idTicket + idTicketInteracao: se já existe na lista, atualiza os
   * dados vindos da API mas preserva excluido/posHorario já definidos pelo usuário.
   * Se não existe, adiciona como novo.
   */
  async function buscarTicketsMoviDesk() {
    if (tipo !== 'S' || !mountedData?.dataEmissao || !modoEdicao) return;

    const response = await ShowLoading(
      () => {
        return api.get('/signed/empresa/suporte/ordensservicos/tickets', {
          params: { dataEmissao: mountedData.dataEmissao },
        });
      },
      { successModal: false, errorModal: false, messageTemplate: 'teste' },
    );

    const ticketsFromAPI = response.data || [];

    setTickets(prevTickets => {
      let lista = [...prevTickets];

      for (const ticketAPI of ticketsFromAPI) {
        const indexExistente = lista.findIndex(
          t =>
            t?.tipo === 'A' &&
            t?.idTicket === ticketAPI?.idTicket &&
            t?.idTicketInteracao === ticketAPI?.idTicketInteracao,
        );

        if (indexExistente === -1) {
          lista.push({
            ...ticketAPI,
            idMovidesk: ticketAPI?.idMoviDesk,
            tipo: 'A',
            check: false,
            excluido: false,
            posHorario: false,
          });
        } else {
          const existente = lista[indexExistente];
          lista[indexExistente] = {
            ...existente,
            ...ticketAPI,
            idMovidesk: ticketAPI?.idMoviDesk,
            tipo: 'A',
            check: existente.check,
            excluido: existente.excluido,
            posHorario: existente.posHorario,
          };
        }
      }

      return lista;
    });
  }

  /**
   * Adiciona a atividade manual (SRP) - só uma por OS, igual ao CreateContent.
   */
  function adicionarAtividadeManual() {
    if (!modoEdicao) return;

    const existingManual = tickets.find(e => e?.tipo === 'M');
    if (existingManual) return;

    const novaAtividadeSRP = {
      idOrdemServico: mountedData?.id,
      idOrdemServicoAtividade: null,
      idProjetoAtividadeItem: null,
      idTicket: 0,
      idTicketInteracao: null,
      idMoviDeskTicket: null,
      tipo: 'M',
      check: true,
      titulo: 'Atividade SRP',
      cliente: 'ERPWorks',
      idMovidesk: '-',
      idMovideskAction: '-',
      status: 'Aguardando',
      categoria: '-',
      protocolo: '',
      descricao: '',
      description: '',
      descricaoHtml: '',
      htmlDescription: '',
      horaTotalMascara: '00:00',
      totalHora: '00:00',
      horaTotal: 0,
      totalHoraMinutos: 0,
      horaTotalMinuto: 0,
      ticket: null,
      ticketInteracao: null,
      atividade: null,
      horarios: [
        {
          idMovideskTime: 0,
          horaInicial: '00:00',
          horaFinal: '00:00',
          horaTrabalhada: '00:00',
          totalHoraMinutos: 0,
        },
      ],
      id: null,
      idEmpresa: mountedData?.idEmpresa || 1,
      idUnidade: mountedData?.idUnidade || 1,
      excluido: false,
      posHorario: false,
    };

    setTickets([...tickets, novaAtividadeSRP]);
  }

  /**
   * useEffect para calcular o total de horas trabalhadas quando os dados da OS são carregados
   * Prioriza a soma das horas dos tickets para tipo Suporte
   * Utiliza campos de formatação de hora alternativos caso não existam tickets
   */
  useEffect(() => {
    if (mountedData && tipo === 'S' && mountedData.tickets?.length > 0) {
      let totalMinutosCalculado = 0;

      for (const ticket of mountedData.tickets) {
        for (const horario of ticket?.horarios ?? []) {
          const horaMinutos =
            parseFloat(horario?.totalHoraMinutos) ||
            parseFloat(horario?.horaUsadaMinuto) ||
            horario?.minHoraFin - horario?.minHoraIni ||
            0;
          totalMinutosCalculado += horaMinutos;
        }
      }

      const horas = parseInt(totalMinutosCalculado / 60);
      const minutos = totalMinutosCalculado % 60;
      const totalCalculado = ('00' + horas).slice(-2) + ':' + ('00' + minutos).slice(-2);

      setTotalHora(totalCalculado);
    } else {
      if (mountedData?.horaTotalMascara) {
        setTotalHora(mountedData.horaTotalMascara);
      } else if (mountedData?.total) {
        setTotalHora(formatarHoraDecimal(mountedData.total));
      } else if (mountedData?.horaTotal) {
        setTotalHora(formatarHoraDecimal(mountedData.horaTotal));
      }
    }
  }, [mountedData, tipo]);

  /**
   * useEffect para processar dados iniciais da OS quando mountedData é carregado
   * Comportamento diferente para tipo Projeto (P) e Suporte (S):
   * - Para Projeto: carrega atividades, horários, clientes e projetos
   * - Para Suporte: processa tickets, calcula horas por ticket e horas totais
   */
  useEffect(() => {
    if (tipo == 'P') {
      let lista = [];
      let listaHor = [];
      let count = 1;
      for (let itemAtv of mountedData?.atividades ?? []) {
        lista.push(itemAtv);

        for (const itemAtivo of itemAtv?.horarios ?? []) {
          listaHor.push({
            id: count,
            titulo: 'º Horário',
            horaInicial: itemAtivo?.horaInicial,
            horaFinal: itemAtivo?.horaFinal,
            idProjetoAtividade: itemAtv?.idProjetoAtividade,
          });

          count++;
        }
      }
      setOrdemServicoAtividades(lista);

      setHorarios(listaHor);

      setClientes([mountedData?.cliente]);
      setProjetos([mountedData?.projeto]);
    } else {
      let tickets = [];

      for (const item of mountedData.tickets) {
        let horarios = [];
        let totalHoraTicket = 0;

        for (const itemHorario of item?.horarios ?? []) {
          const horaMinutos =
            parseFloat(itemHorario?.totalHoraMinutos) ||
            parseFloat(itemHorario?.horaUsadaMinuto) ||
            itemHorario?.minHoraFin - itemHorario?.minHoraIni ||
            0;

          totalHoraTicket += horaMinutos;

          const formatarHora = hora => {
            if (!hora) return '';
            return hora.length > 5 ? hora.substring(0, 5) : hora;
          };

          horarios.push({
            idMovideskTime: itemHorario?.idMovideskTime || 0,
            horaInicial: formatarHora(itemHorario?.horaInicial),
            horaFinal: formatarHora(itemHorario?.horaFinal),
            horaTrabalhada:
              itemHorario?.horaTotalMascara || formatarHora(itemHorario?.horaTrabalhada),
            totalHoraMinutos: horaMinutos,
          });
        }

        let horas = parseInt(totalHoraTicket / 60);
        let minutos = totalHoraTicket % 60;
        const totalHoraCalculado = ('00' + horas).slice(-2) + ':' + ('00' + minutos).slice(-2);

        const isComplementar =
          !item.ticket || !item.ticketInteracao || item.titulo === 'Atividade SRP';
        const tipoTicket = isComplementar ? 'M' : 'A';

        tickets.push({
          idOrdemServico: mountedData?.id,
          idOrdemServicoAtividade: item?.idOrdemServicoAtividade,
          idProjetoAtividadeItem: item?.idProjetoAtividadeItem,
          idTicket: item?.idTicket,
          idTicketInteracao: item?.idTicketInteracao,
          idMoviDeskTicket: item?.ticket?.idMoviDeskTicket,
          tipo: tipoTicket,
          check: false,
          titulo: item?.titulo,
          cliente: item?.ticket?.nomeCliente || 'ERPWorks',
          idMovidesk: item?.ticket?.idMoviDesk,
          idMovideskAction: item?.ticketInteracao?.idMoviDesk,
          status: item?.ticket?.status || 'Fechado',
          categoria: item?.ticket?.categoria || '',
          protocolo: item?.ticket?.protocolo || '',
          descricao: item?.descricao,
          description: item?.descricao,
          descricaoHtml: item?.descricaoHTML || '',
          htmlDescription: item?.descricaoHTML || '',
          horaTotalMascara: totalHoraCalculado,
          totalHora: totalHoraCalculado,
          horaTotal: parseFloat((totalHoraTicket / 60).toFixed(2)),
          totalHoraMinutos: totalHoraTicket,
          horaTotalMinuto: totalHoraTicket,
          ticket: item?.ticket || null,
          ticketInteracao: item?.ticketInteracao || null,
          atividade: item?.atividade || null,
          horarios,
          id: item?.id || null,
          idEmpresa: mountedData?.idEmpresa || 1,
          idUnidade: mountedData?.idUnidade || 1,
          excluido: !!item?.excluido,
          posHorario: !!item?.posHorario,
        });
      }

      const totalHoraMinutos = tickets.reduce(
        (soma, ticket) => (ticket?.excluido ? soma : soma + (ticket?.totalHoraMinutos || 0)),
        0,
      );

      if (totalHoraMinutos > 0) {
        let horas = parseInt(totalHoraMinutos / 60);
        let minutos = totalHoraMinutos % 60;
        const novoTotal = ('00' + horas).slice(-2) + ':' + ('00' + minutos).slice(-2);
        setTotalHora(novoTotal);
      }

      setTickets(tickets);
    }
  }, [mountedData]);

  /**
   * useEffect para recalcular o total de horas quando tickets são selecionados ou alterados
   * Atualiza o total de horas no formato HH:MM
   */
  useEffect(() => {
    if (tipo === 'S' && tickets.length > 0) {
      let totalHoraMinutos = 0;
      let totalPosHoraMinutos = 0;
      let temTicketSelecionado = false;

      for (const ticket of tickets) {
        if (ticket?.excluido) continue;
        totalHoraMinutos += parseFloat(ticket?.totalHoraMinutos || 0);
        if (ticket?.posHorario) {
          totalPosHoraMinutos += parseFloat(ticket?.totalHoraMinutos || 0);
        }
        temTicketSelecionado = true;
      }

      if (temTicketSelecionado) {
        let horas = parseInt(totalHoraMinutos / 60);
        let minutos = totalHoraMinutos % 60;

        setTotalHora(('00' + horas).slice(-2) + ':' + ('00' + minutos).slice(-2));

        let horasPos = parseInt(totalPosHoraMinutos / 60);
        let minutosPos = totalPosHoraMinutos % 60;

        setTotalPosHorario(('00' + horasPos).slice(-2) + ':' + ('00' + minutosPos).slice(-2));
      }
    }
  }, [tickets, tipo]);

  /**
   * Função para submeter os dados da Ordem de Serviço
   * Comportamento diferente para tipo Projeto (P) e Suporte (S):
   * - Para Projeto: faz requisição PUT para atualizar a OS
   * - Para Suporte: apenas fecha o modal e faz reload
   *
   * @param {Object} data - Dados do formulário para submeter
   * @param {Object} options - Opções adicionais (closeReload para fechar e recarregar)
   * @returns {Promise} - Promessa com a resposta da API
   */
  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    if (tipo == 'P') {
      return ShowConfirmacao(
        async () => {
          let thisData = {
            ...data,
            horarios,
            id: mountedData?.id,
            atividades: ordemServicoAtividades,
          };

          console.log('[EditContent OS] tipo Projeto - payload enviado para PUT:', thisData);

          let response = await api.put('/signed/empresa/suporte/ordemservico', thisData);
          console.log('[EditContent OS] tipo Projeto - resposta recebida:', response);
          if (response?.status === 200) {
            closeReload && closeReload();
          }
          return response;
        },
        {
          errorModal: {
            defaultMessage: `Ocorreu um erro ao cadastrar essa Ordem de Serviço, por favor, tente novamente mais tarde.`,
          },
          message: `Tem certeza que deseja cadastrar essa Ordem de Serviço?`,
          successModal: `Ordem de Serviço cadastrada com sucesso!`,
        },
      );
    } else {
      return ShowConfirmacao(
        async () => {
          let thisData = {
            ...mountedData,
            ...data,
            tipo,
            horarios,
            id: mountedData?.id,
            atividades: ordemServicoAtividades,
            horaDesconto: 0,
            horaTranslado: 0,
            tickets,
          };

          let response = await api.put('/signed/empresa/suporte/ordemservico', thisData);
          if (response?.status === 200) {
            closeReload && closeReload();
          }
          return response;
        },
        {
          errorModal: {
            defaultMessage: `Ocorreu um erro ao cadastrar essa Ordem de Serviço, por favor, tente novamente mais tarde.`,
          },
          message: `Tem certeza que deseja cadastrar essa Ordem de Serviço?`,
          successModal: `Ordem de Serviço cadastrada com sucesso!`,
        },
      );
    }
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        {tipo == 'S' ? (
          <div>
            <div className="row">
              <Label title="Tipo" className="col s12 m6 l2">
                <Select
                  isString
                  list={{
                    list: [
                      { id: 'S', titulo: 'Suporte' },
                      { id: 'P', titulo: 'Projeto' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  disabled="true"
                  name="tipo"
                  defaultValue={tipo}
                />
              </Label>
              <Label title="Data *" className="col s12 m6 l2">
                <Input
                  type="date"
                  name="dataEmissao"
                  required="true"
                  defaultValue={mountedData?.dataEmissao}
                  disabled="true"
                />
              </Label>
              <Label title="Título *" className="col s12 m8 l4">
                <Input
                  name="titulo"
                  required="true"
                  disabled={!modoEdicao}
                  defaultValue={mountedData?.titulo}
                />
              </Label>
              <Label title="Total Pós-Horário" className="col s12 m4 l2">
                <Input name="totalPosHorario" disabled="true" value={totalPosHorario} />
              </Label>
              <Label title="Total OS *" className="col s12 m4 l2">
                <Input name="totalOS" disabled="true" value={totalHora} required="true" />
              </Label>
            </div>
            <div className="row">
              <div className="content-top" style={{ marginBottom: '14px' }}>
                <p className="title_p">Atividades *</p>
                {modoEdicao && (
                  <div className="botoes-atividades">
                    <div className="novo-horario buscar-movidesk" onClick={buscarTicketsMoviDesk}>
                      <img src={IconRestaurar} alt="sincronizar" />
                      <p className="adiciona-horario">Sincronizar</p>
                    </div>
                    <div className="novo-horario" onClick={adicionarAtividadeManual}>
                      <p className="adiciona-horario">Adicionar</p>
                    </div>
                  </div>
                )}
              </div>
              <div className="col s12 m12 l12">
                <ItemTicket item={false}>
                  <div className="col s1 m1 l1">
                    <p className="text-col">Id Ticket</p>
                  </div>
                  <div className="col s1 m1 l1">
                    <p className="text-col">Id Interacao</p>
                  </div>
                  <div className="col s3 m3 l3">
                    <p className="text-col">Cliente</p>
                  </div>
                  <div className="col s5 m5 l5">
                    <p className="text-col">Titulo Ticket</p>
                  </div>
                  <div className="col s1 m1 l1">
                    <p className="text-col">Tot. Hora</p>
                  </div>
                  <div className="col s2 m2 l2">
                    <p className="text-col" style={{ textAlign: 'right', width: '100%' }}>
                      SRP Autorizado
                    </p>
                  </div>
                </ItemTicket>
                <div className="content-atividade">
                  {[...(tickets || [])]
                    .sort((a, b) =>
                      getPrimeiraHoraInicial(a).localeCompare(getPrimeiraHoraInicial(b)),
                    )
                    .map((item, index) => (
                      <SecaoTicket
                        key={`${item?.idTicket}-${item?.idMovidesk}-${item?.idMovideskAction}-${index}`}
                      >
                        <ItemTicket
                          item={true}
                          excluido={item?.excluido}
                          onClick={() => {
                            if (item?.tipo === 'M' || item?.excluido) return;

                            let lista = [];
                            for (let itemTicket of tickets) {
                              if (
                                item?.idMovidesk === itemTicket?.idMovidesk &&
                                item?.idMovideskAction === itemTicket?.idMovideskAction &&
                                item?.idTicket === itemTicket?.idTicket
                              ) {
                                lista.push({ ...itemTicket, check: !itemTicket?.check });
                              } else {
                                lista.push({ ...itemTicket });
                              }
                            }

                            setTickets(lista);
                          }}
                        >
                          <div className="col s1 m1 l1">
                            <p
                              className="text-col"
                              style={{ marginLeft: item?.idMovidesk ? 'auto' : '20px' }}
                            >
                              {item?.idMovidesk ? `#${item?.idMovidesk}` : '-'}
                            </p>
                          </div>
                          <div className="col s1 m1 l1">
                            <p className="text-col">
                              {item?.idMovideskAction ? `${item?.idMovideskAction}` : '-'}
                            </p>
                          </div>
                          <div className="col s3 m3 l3">
                            <p className="text-col">{item?.cliente}</p>
                          </div>
                          <div className="col s5 m5 l5">
                            <p className="text-col">{item?.titulo}</p>
                          </div>
                          <div className="col s1 m1 l1">
                            <p className="text-col">{item?.totalHora}</p>
                          </div>
                          <div className="col s2 m2 l2 col-acoes-final">
                            {item?.tipo !== 'M' && (
                              <ToggleSwitch onClick={e => e.stopPropagation()}>
                                <input
                                  type="checkbox"
                                  checked={!!item?.posHorario}
                                  disabled={item?.excluido || !modoEdicao}
                                  onChange={e =>
                                    atualizarCampoTicket(
                                      item,
                                      'posHorario',
                                      e.currentTarget.checked,
                                    )
                                  }
                                />
                                <span className="slider" />
                              </ToggleSwitch>
                            )}
                            {/* Botão de excluir/restaurar OS removido da tela a pedido.
                            {item?.excluido ? (
                              <img
                                src={IconRestaurar}
                                alt="restaurar"
                                style={
                                  !modoEdicao ? { opacity: 0.4, cursor: 'not-allowed' } : undefined
                                }
                                onClick={e => {
                                  e.stopPropagation();
                                  if (!modoEdicao) return;
                                  atualizarCampoTicket(item, 'excluido', false);
                                }}
                              />
                            ) : (
                              <img
                                src={IconLixeira}
                                alt="lixeira"
                                style={
                                  !modoEdicao ? { opacity: 0.4, cursor: 'not-allowed' } : undefined
                                }
                                onClick={e => {
                                  e.stopPropagation();
                                  if (!modoEdicao) return;
                                  atualizarCampoTicket(item, 'excluido', true);
                                }}
                              />
                            )}
                            */}
                          </div>
                        </ItemTicket>
                        {(item?.check == true || item?.tipo === 'M') && !item?.excluido && (
                          <div className="atv-content-body">
                            <div className="col s12 m7 l7">
                              {item?.tipo === 'M' ? (
                                <Label title="Descrição *" className="col s12 m12 l12">
                                  <TextArea
                                    name="descricao"
                                    required="true"
                                    disabled={!(modoEdicao && item?.tipo === 'M')}
                                    defaultValue={item?.descricao}
                                    onChange={e => {
                                      const v = e.currentTarget.value || '';

                                      const newTickets = [...tickets];
                                      const ticketIndex = newTickets.findIndex(
                                        t => t.idTicket === item.idTicket && t.tipo === 'M',
                                      );

                                      if (ticketIndex !== -1) {
                                        newTickets[ticketIndex] = {
                                          ...newTickets[ticketIndex],
                                          descricao: v,
                                          description: v,
                                        };

                                        setTickets(newTickets);
                                      }
                                    }}
                                  />
                                </Label>
                              ) : (
                                <p
                                  className={
                                    item?.htmlDescription ? 'item-desc' : 'item-desc no-html'
                                  }
                                >
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.htmlDescription
                                        ? item?.htmlDescription
                                        : item?.description,
                                    }}
                                  ></div>
                                </p>
                              )}
                            </div>
                            <div className="col s12 m5 l5">
                              {[...(item?.horarios || [])]
                                .sort((a, b) =>
                                  (a?.horaInicial || '').localeCompare(b?.horaInicial || ''),
                                )
                                .map((itemHorario, index) => (
                                  <div className="item-horario" key={index}>
                                    <div className="col s12 m8 l11">
                                      <Label title="Hora Inicial" className="col s6 m6 l6">
                                        <Input
                                          type="time"
                                          name="horaInicial"
                                          disabled={!(modoEdicao && item?.tipo === 'M')}
                                          value={itemHorario?.horaInicial}
                                          onChange={e => {
                                            if (modoEdicao && item?.tipo === 'M') {
                                              const newHorarios = [...item.horarios];
                                              const originalIndex =
                                                item.horarios.indexOf(itemHorario);
                                              newHorarios[originalIndex] = {
                                                ...newHorarios[originalIndex],
                                                horaInicial: e.target.value,
                                              };

                                              const newTickets = [...tickets];
                                              const ticketIndex = newTickets.findIndex(
                                                t => t.idTicket === item.idTicket && t.tipo === 'M',
                                              );

                                              if (ticketIndex !== -1) {
                                                newTickets[ticketIndex] = {
                                                  ...newTickets[ticketIndex],
                                                  horarios: newHorarios,
                                                };

                                                // Recalcula o total de horas do ticket
                                                const horaInicial =
                                                  newHorarios[originalIndex].horaInicial;
                                                const horaFinal =
                                                  newHorarios[originalIndex].horaFinal;

                                                if (horaInicial && horaFinal) {
                                                  const [horaIni, minIni] = horaInicial
                                                    .split(':')
                                                    .map(Number);
                                                  const [horaFim, minFim] = horaFinal
                                                    .split(':')
                                                    .map(Number);

                                                  const minHoraIni = horaIni * 60 + minIni;
                                                  const minHoraFin = horaFim * 60 + minFim;

                                                  const totalMinutos = minHoraFin - minHoraIni;

                                                  if (totalMinutos > 0) {
                                                    newHorarios[originalIndex].totalHoraMinutos =
                                                      totalMinutos;
                                                    newHorarios[originalIndex].horaTrabalhada =
                                                      ('00' + Math.floor(totalMinutos / 60)).slice(
                                                        -2,
                                                      ) +
                                                      ':' +
                                                      ('00' + (totalMinutos % 60)).slice(-2);

                                                    // Calcula total de horas do ticket
                                                    let ticketTotalMinutos = 0;
                                                    for (const h of newHorarios) {
                                                      ticketTotalMinutos += parseFloat(
                                                        h.totalHoraMinutos || 0,
                                                      );
                                                    }

                                                    const ticketHoras = Math.floor(
                                                      ticketTotalMinutos / 60,
                                                    );
                                                    const ticketMinutos = ticketTotalMinutos % 60;

                                                    newTickets[ticketIndex].totalHoraMinutos =
                                                      ticketTotalMinutos;
                                                    newTickets[ticketIndex].totalHora =
                                                      ('00' + ticketHoras).slice(-2) +
                                                      ':' +
                                                      ('00' + ticketMinutos).slice(-2);
                                                  }
                                                }

                                                setTickets(newTickets);
                                              }
                                            }
                                          }}
                                        />
                                      </Label>
                                      <Label title="Hora Final" className="col s6 m6 l6">
                                        <Input
                                          type="time"
                                          name="horaFinal"
                                          disabled={!(modoEdicao && item?.tipo === 'M')}
                                          value={itemHorario?.horaFinal}
                                          onChange={e => {
                                            if (modoEdicao && item?.tipo === 'M') {
                                              const newHorarios = [...item.horarios];
                                              const originalIndex =
                                                item.horarios.indexOf(itemHorario);
                                              newHorarios[originalIndex] = {
                                                ...newHorarios[originalIndex],
                                                horaFinal: e.target.value,
                                              };

                                              const newTickets = [...tickets];
                                              const ticketIndex = newTickets.findIndex(
                                                t => t.idTicket === item.idTicket && t.tipo === 'M',
                                              );

                                              if (ticketIndex !== -1) {
                                                newTickets[ticketIndex] = {
                                                  ...newTickets[ticketIndex],
                                                  horarios: newHorarios,
                                                };

                                                // Recalcula o total de horas do ticket
                                                const horaInicial =
                                                  newHorarios[originalIndex].horaInicial;
                                                const horaFinal =
                                                  newHorarios[originalIndex].horaFinal;

                                                if (horaInicial && horaFinal) {
                                                  const [horaIni, minIni] = horaInicial
                                                    .split(':')
                                                    .map(Number);
                                                  const [horaFim, minFim] = horaFinal
                                                    .split(':')
                                                    .map(Number);

                                                  const minHoraIni = horaIni * 60 + minIni;
                                                  const minHoraFin = horaFim * 60 + minFim;

                                                  const totalMinutos = minHoraFin - minHoraIni;

                                                  if (totalMinutos > 0) {
                                                    newHorarios[originalIndex].totalHoraMinutos =
                                                      totalMinutos;
                                                    newHorarios[originalIndex].horaTrabalhada =
                                                      ('00' + Math.floor(totalMinutos / 60)).slice(
                                                        -2,
                                                      ) +
                                                      ':' +
                                                      ('00' + (totalMinutos % 60)).slice(-2);

                                                    // Calcula total de horas do ticket
                                                    let ticketTotalMinutos = 0;
                                                    for (const h of newHorarios) {
                                                      ticketTotalMinutos += parseFloat(
                                                        h.totalHoraMinutos || 0,
                                                      );
                                                    }

                                                    const ticketHoras = Math.floor(
                                                      ticketTotalMinutos / 60,
                                                    );
                                                    const ticketMinutos = ticketTotalMinutos % 60;

                                                    newTickets[ticketIndex].totalHoraMinutos =
                                                      ticketTotalMinutos;
                                                    newTickets[ticketIndex].totalHora =
                                                      ('00' + ticketHoras).slice(-2) +
                                                      ':' +
                                                      ('00' + ticketMinutos).slice(-2);
                                                  }
                                                }

                                                setTickets(newTickets);
                                              }
                                            }
                                          }}
                                        />
                                      </Label>
                                    </div>
                                    <div className="col s12 m4 l1"></div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )}
                      </SecaoTicket>
                    ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="col s8 m8 l8">
              <div className="row">
                <Label title="Data *" className="col s6 m4 l3">
                  <Input
                    type="date"
                    name="dataEmissao"
                    required="true"
                    defaultValue={mountedData?.dataEmissao}
                    min={mountedData?.atividades[0].projetoAtividade?.previsaoInicio}
                    max={mountedData?.atividades[0].projetoAtividade?.previsaoEntrega}
                  />
                </Label>
                <Label title="Título *" className="col s6 m8 l9">
                  <Input name="titulo" required="true" defaultValue={mountedData?.titulo} />
                </Label>
              </div>
              <div className="row no-margin">
                <Label title="Cliente *" className="col s4 m4 l4">
                  <Select
                    required="true"
                    isString
                    list={{
                      list: clientes,
                      value: 'id',
                      label: 'nomeFantasia',
                    }}
                    name="idCliente"
                    defaultValue={mountedData?.idCliente}
                  />
                </Label>
                <Label title="Projeto *" className="col s4 m4 l4">
                  <Select
                    required="true"
                    isString
                    list={{
                      list: projetos,
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="idProjeto"
                    defaultValue={mountedData?.idProjeto}
                  />
                </Label>
                <Label title="Desconto" className="col s2 m2 l2">
                  <Select
                    isString
                    list={{
                      list: [
                        { id: '00:00', titulo: '00:00' },
                        { id: '00:15', titulo: '00:15' },
                        { id: '00:30', titulo: '00:30' },
                        { id: '00:45', titulo: '00:45' },
                        { id: '01:00', titulo: '01:00' },
                        { id: '01:15', titulo: '01:15' },
                        { id: '01:30', titulo: '01:30' },
                        { id: '01:45', titulo: '01:45' },
                        { id: '02:00', titulo: '02:00' },
                        { id: '02:15', titulo: '02:15' },
                        { id: '02:30', titulo: '02:30' },
                        { id: '02:45', titulo: '02:45' },
                        { id: '03:00', titulo: '03:00' },
                        { id: '03:15', titulo: '03:15' },
                        { id: '03:30', titulo: '03:30' },
                        { id: '03:45', titulo: '03:45' },
                        { id: '04:00', titulo: '04:00' },
                        { id: '04:15', titulo: '04:15' },
                        { id: '04:30', titulo: '04:30' },
                        { id: '04:45', titulo: '04:45' },
                        { id: '05:00', titulo: '05:00' },
                        { id: '05:15', titulo: '05:15' },
                        { id: '05:30', titulo: '05:30' },
                        { id: '05:45', titulo: '05:45' },
                        { id: '06:00', titulo: '06:00' },
                        { id: '06:15', titulo: '06:15' },
                        { id: '06:30', titulo: '06:30' },
                        { id: '06:45', titulo: '06:45' },
                        { id: '07:00', titulo: '07:00' },
                        { id: '07:15', titulo: '07:15' },
                        { id: '07:30', titulo: '07:30' },
                        { id: '07:45', titulo: '07:45' },
                        { id: '08:00', titulo: '08:00' },
                        { id: '08:15', titulo: '08:15' },
                        { id: '08:30', titulo: '08:30' },
                        { id: '08:45', titulo: '08:45' },
                        { id: '09:00', titulo: '09:00' },
                        { id: '09:15', titulo: '09:15' },
                        { id: '09:30', titulo: '09:30' },
                        { id: '09:45', titulo: '09:45' },
                        { id: '10:00', titulo: '10:00' },
                        { id: '10:15', titulo: '10:15' },
                        { id: '10:30', titulo: '10:30' },
                        { id: '10:45', titulo: '10:45' },
                        { id: '11:00', titulo: '11:00' },
                        { id: '11:15', titulo: '11:15' },
                        { id: '11:30', titulo: '11:30' },
                        { id: '11:45', titulo: '11:45' },
                        { id: '12:00', titulo: '12:00' },
                        { id: '12:15', titulo: '12:15' },
                        { id: '12:30', titulo: '12:30' },
                        { id: '12:45', titulo: '12:45' },
                        { id: '13:00', titulo: '13:00' },
                        { id: '13:15', titulo: '13:15' },
                        { id: '13:30', titulo: '13:30' },
                        { id: '13:45', titulo: '13:45' },
                        { id: '14:00', titulo: '14:00' },
                        { id: '14:15', titulo: '14:15' },
                        { id: '14:30', titulo: '14:30' },
                        { id: '14:45', titulo: '14:45' },
                        { id: '15:00', titulo: '15:00' },
                        { id: '15:15', titulo: '15:15' },
                        { id: '15:30', titulo: '15:30' },
                        { id: '15:45', titulo: '15:45' },
                        { id: '16:00', titulo: '16:00' },
                        { id: '16:15', titulo: '16:15' },
                        { id: '16:30', titulo: '16:30' },
                        { id: '16:45', titulo: '16:45' },
                        { id: '17:00', titulo: '17:00' },
                        { id: '17:15', titulo: '17:15' },
                        { id: '17:30', titulo: '17:30' },
                        { id: '17:45', titulo: '17:45' },
                        { id: '18:00', titulo: '18:00' },
                        { id: '18:15', titulo: '18:15' },
                        { id: '18:30', titulo: '18:30' },
                        { id: '18:45', titulo: '18:45' },
                        { id: '19:00', titulo: '19:00' },
                        { id: '19:15', titulo: '19:15' },
                        { id: '19:30', titulo: '19:30' },
                        { id: '19:45', titulo: '19:45' },
                        { id: '20:00', titulo: '20:00' },
                        { id: '20:15', titulo: '20:15' },
                        { id: '20:30', titulo: '20:30' },
                        { id: '20:45', titulo: '20:45' },
                        { id: '21:00', titulo: '21:00' },
                        { id: '21:15', titulo: '21:15' },
                        { id: '21:30', titulo: '21:30' },
                        { id: '21:45', titulo: '18:45' },
                        { id: '22:00', titulo: '22:00' },
                        { id: '22:15', titulo: '22:15' },
                        { id: '22:30', titulo: '22:30' },
                        { id: '22:45', titulo: '22:45' },
                        { id: '23:00', titulo: '23:00' },
                        { id: '23:15', titulo: '23:15' },
                        { id: '23:30', titulo: '23:30' },
                        { id: '23:45', titulo: '23:45' },
                      ],
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="horaDesconto"
                    defaultValue={mountedData?.horaDescontoMascara}
                  />
                </Label>
                <Label title="Translado" className="col s2 m2 l2">
                  <Select
                    isString
                    list={{
                      list: [
                        { id: '00:00', titulo: '00:00' },
                        { id: '00:15', titulo: '00:15' },
                        { id: '00:30', titulo: '00:30' },
                        { id: '00:45', titulo: '00:45' },
                        { id: '01:00', titulo: '01:00' },
                        { id: '01:15', titulo: '01:15' },
                        { id: '01:30', titulo: '01:30' },
                        { id: '01:45', titulo: '01:45' },
                        { id: '02:00', titulo: '02:00' },
                        { id: '02:15', titulo: '02:15' },
                        { id: '02:30', titulo: '02:30' },
                        { id: '02:45', titulo: '02:45' },
                        { id: '03:00', titulo: '03:00' },
                        { id: '03:15', titulo: '03:15' },
                        { id: '03:30', titulo: '03:30' },
                        { id: '03:45', titulo: '03:45' },
                        { id: '04:00', titulo: '04:00' },
                        { id: '04:15', titulo: '04:15' },
                        { id: '04:30', titulo: '04:30' },
                        { id: '04:45', titulo: '04:45' },
                        { id: '05:00', titulo: '05:00' },
                        { id: '05:15', titulo: '05:15' },
                        { id: '05:30', titulo: '05:30' },
                        { id: '05:45', titulo: '05:45' },
                        { id: '06:00', titulo: '06:00' },
                        { id: '06:15', titulo: '06:15' },
                        { id: '06:30', titulo: '06:30' },
                        { id: '06:45', titulo: '06:45' },
                        { id: '07:00', titulo: '07:00' },
                        { id: '07:15', titulo: '07:15' },
                        { id: '07:30', titulo: '07:30' },
                        { id: '07:45', titulo: '07:45' },
                        { id: '08:00', titulo: '08:00' },
                        { id: '08:15', titulo: '08:15' },
                        { id: '08:30', titulo: '08:30' },
                        { id: '08:45', titulo: '08:45' },
                        { id: '09:00', titulo: '09:00' },
                        { id: '09:15', titulo: '09:15' },
                        { id: '09:30', titulo: '09:30' },
                        { id: '09:45', titulo: '09:45' },
                        { id: '10:00', titulo: '10:00' },
                        { id: '10:15', titulo: '10:15' },
                        { id: '10:30', titulo: '10:30' },
                        { id: '10:45', titulo: '10:45' },
                        { id: '11:00', titulo: '11:00' },
                        { id: '11:15', titulo: '11:15' },
                        { id: '11:30', titulo: '11:30' },
                        { id: '11:45', titulo: '11:45' },
                        { id: '12:00', titulo: '12:00' },
                        { id: '12:15', titulo: '12:15' },
                        { id: '12:30', titulo: '12:30' },
                        { id: '12:45', titulo: '12:45' },
                        { id: '13:00', titulo: '13:00' },
                        { id: '13:15', titulo: '13:15' },
                        { id: '13:30', titulo: '13:30' },
                        { id: '13:45', titulo: '13:45' },
                        { id: '14:00', titulo: '14:00' },
                        { id: '14:15', titulo: '14:15' },
                        { id: '14:30', titulo: '14:30' },
                        { id: '14:45', titulo: '14:45' },
                        { id: '15:00', titulo: '15:00' },
                        { id: '15:15', titulo: '15:15' },
                        { id: '15:30', titulo: '15:30' },
                        { id: '15:45', titulo: '15:45' },
                        { id: '16:00', titulo: '16:00' },
                        { id: '16:15', titulo: '16:15' },
                        { id: '16:30', titulo: '16:30' },
                        { id: '16:45', titulo: '16:45' },
                        { id: '17:00', titulo: '17:00' },
                        { id: '17:15', titulo: '17:15' },
                        { id: '17:30', titulo: '17:30' },
                        { id: '17:45', titulo: '17:45' },
                        { id: '18:00', titulo: '18:00' },
                        { id: '18:15', titulo: '18:15' },
                        { id: '18:30', titulo: '18:30' },
                        { id: '18:45', titulo: '18:45' },
                        { id: '19:00', titulo: '19:00' },
                        { id: '19:15', titulo: '19:15' },
                        { id: '19:30', titulo: '19:30' },
                        { id: '19:45', titulo: '19:45' },
                        { id: '20:00', titulo: '20:00' },
                        { id: '20:15', titulo: '20:15' },
                        { id: '20:30', titulo: '20:30' },
                        { id: '20:45', titulo: '20:45' },
                        { id: '21:00', titulo: '21:00' },
                        { id: '21:15', titulo: '21:15' },
                        { id: '21:30', titulo: '21:30' },
                        { id: '21:45', titulo: '18:45' },
                        { id: '22:00', titulo: '22:00' },
                        { id: '22:15', titulo: '22:15' },
                        { id: '22:30', titulo: '22:30' },
                        { id: '22:45', titulo: '22:45' },
                        { id: '23:00', titulo: '23:00' },
                        { id: '23:15', titulo: '23:15' },
                        { id: '23:30', titulo: '23:30' },
                        { id: '23:45', titulo: '23:45' },
                      ],
                      value: 'id',
                      label: 'titulo',
                    }}
                    name="horaTranslado"
                    defaultValue={mountedData?.horaTransladoMascara}
                  />
                </Label>
              </div>
              <div className="row no-margin">
                <Label title="Observação de Aprovado/Reprovado" className="col s12 m12 l12">
                  <TextArea
                    name="observacaoAprovDesaprov"
                    required="false"
                    defaultValue={mountedData?.observacao}
                    readOnly="true"
                  />
                </Label>
              </div>
              <div className="row">
                <div className="col s12 m12 l12">
                  <p className="title_p">Atividades *</p>
                  <div className="content-atividade">
                    {ordemServicoAtividades?.map((item, index) => (
                      <div className="atv-content" key={index}>
                        <div className="atv-content-top">
                          <div className="card-titulo">
                            <p className="titulo">
                              {item?.id} - {item?.titulo}
                            </p>
                          </div>
                          <div className="card-check checked">
                            <span />
                          </div>
                        </div>
                        <div className="atv-content-body">
                          <Label title="Descrição *" className="col s12 m12 l12">
                            <TextArea
                              name="descricao"
                              required="false"
                              defaultValue={item?.descricao}
                              onChange={e => {
                                const v = e.currentTarget.value || '';

                                let lista = [];
                                for (const itemAtivo of ordemServicoAtividades) {
                                  if (itemAtivo?.id == item?.id) {
                                    lista.push({ ...itemAtivo, descricao: v });
                                  } else {
                                    lista.push(itemAtivo);
                                  }
                                }

                                setOrdemServicoAtividades(lista);
                              }}
                            />
                          </Label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col s4 m4 l4">
              <p className="title_p">Horários *</p>
              <div className="row-left">
                <div className="col s12 m12 l12">
                  {horarios &&
                    horarios?.map(item => (
                      <div className="content" key={item?.id}>
                        <div className="content-top">
                          <div className="card-cod">
                            <p className="cod">
                              {item?.id} {item?.titulo}
                            </p>
                          </div>
                          <img
                            src={IconLixeira}
                            alt="lixeira"
                            onClick={() => {
                              if (horarios.length > 1) {
                                const itemFind = horarios?.find(d => d?.id == item?.id);
                                let lista = [];
                                for (let itemHor of horarios) {
                                  if (itemFind?.id != itemHor?.id) {
                                    lista.push(itemHor);
                                  }
                                }
                                setHorarios(lista);
                              }
                            }}
                          />
                        </div>
                        <div className="content-body">
                          <Label title="Atividade *" className="col s12 m12 l12">
                            <Select
                              isString
                              list={{
                                list: ordemServicoAtividades,
                                value: 'idProjetoAtividade',
                                label: 'titulo',
                              }}
                              name="idProjetoAtividade"
                              value={item?.idProjetoAtividade}
                              onChange={e => {
                                const v = e.currentTarget.value || 0;

                                let lista = [];
                                for (const itemAtivo of horarios) {
                                  if (itemAtivo?.id == item?.id) {
                                    lista.push({ ...itemAtivo, idProjetoAtividade: v });
                                  } else {
                                    lista.push(itemAtivo);
                                  }
                                }

                                setHorarios(lista);
                              }}
                            />
                          </Label>
                          <Label title="Hora Inicial *" className="col s6 m6 l6">
                            <Input
                              type="time"
                              name="horaInicial"
                              required="true"
                              value={item?.horaInicial}
                              onChange={e => {
                                const v = e.currentTarget.value || '00:00';

                                let lista = [];
                                for (const itemAtivo of horarios) {
                                  if (itemAtivo?.id == item?.id) {
                                    lista.push({ ...itemAtivo, horaInicial: v });
                                  } else {
                                    lista.push(itemAtivo);
                                  }
                                }

                                setHorarios(lista);
                              }}
                            />
                          </Label>
                          <Label title="Hora Final *" className="col s6 m6 l6">
                            <Input
                              type="time"
                              name="horaFinal"
                              required="true"
                              value={item?.horaFinal}
                              onChange={e => {
                                const v = e.currentTarget.value || '';

                                let lista = [];
                                for (const itemAtivo of horarios) {
                                  if (itemAtivo?.id == item?.id) {
                                    lista.push({ ...itemAtivo, horaFinal: v });
                                  } else {
                                    lista.push(itemAtivo);
                                  }
                                }

                                setHorarios(lista);
                              }}
                            />
                          </Label>
                        </div>
                      </div>
                    ))}
                </div>
                <div
                  className="novo-horario"
                  onClick={() => {
                    let lista = [];
                    for (const itemHor of horarios) {
                      lista.push(itemHor);
                    }

                    lista.push({
                      id: horarios[horarios.length - 1]?.id + 1,
                      titulo: 'º Horário',
                      horaInicial: '08:00',
                      horaFinal: '12:00',
                      idProjetoAtividade:
                        ordemServicoAtividades?.length > 0
                          ? ordemServicoAtividades[0]?.idProjetoAtividade
                          : 0,
                    });
                    setHorarios(lista);
                  }}
                >
                  <p className="adiciona-horario">Adicionar</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </Materialize>
    </Container>
  );
}

export default CreateContent;
